import { FaqTray } from '../../../domain/faq-tray';
import { CreateMarketingFaqPageItemApiModel, CreateMarketingTargetedFaqPageItemApiModel } from '@cxb/editor-stb-api';
import { mapperPipe, PlatformType, remainderMapper } from 'osn-shared';
import { platformTargetingMapper } from '../../mapping/create-tray-domain-to-api';
import { MarketingFaqPageItemApiModel, MarketingTargetedFaqPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import { commonMapper } from '../../mapping/create-tray-api-to-domain';
import { FaqTrayFormViewModel } from './faq-tray-form-view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';

// 'FaqTray'

/**
 * DOMAIN -> API
 */

export const mapDomainFaqTrayToApi = (
  tray: FaqTray,
  isTargeted: boolean,
  pageVersionId?: string,
  tenantId?: string
): CreateMarketingFaqPageItemApiModel | CreateMarketingTargetedFaqPageItemApiModel => {
  const commonProperties = mapperPipe(tray, platformTargetingMapper);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    moduleName: tray.name,
    headLineLocalized: { en: tray.headlineTextEnglish, ar: tray.headlineTextArabic },
    questions: tray.questions.map((question, index) => ({ question: question.questionText, answer: question.answerText, order: index })),
    tenantId,
    ...(isTargeted && { countryIds: tray.countryIds, userSegmentIds: tray.userSegmentIds }),
  }));
};

/**
 * API -> DOMAIN
 */

export const mapApiFaqTrayToDomain = (tray: MarketingFaqPageItemApiModel | MarketingTargetedFaqPageItemApiModel): FaqTray => {
  return remainderMapper(mapperPipe(tray, commonMapper), () => ({
    id: tray.id,
    name: tray.moduleName,
    headlineTextArabic: tray.headLineLocalized.ar,
    headlineTextEnglish: tray.headLineLocalized.en,
    visible: undefined,
    order: undefined,
    draggable: false,
    type: 'FaqTray',
    countryIds: (tray as MarketingTargetedFaqPageItemApiModel).countries?.map((country) => country.id),
    userSegmentIds: (tray as MarketingTargetedFaqPageItemApiModel).userSegments?.map((userSegment) => userSegment.id),
    questions: tray.questions.map((question) => ({ questionText: question.question, answerText: question.answer })),
    platformIds: [],
  }));
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapDomainFaqTrayToViewModel = (tray: FaqTray): FaqTrayFormViewModel => {
  return {
    id: tray.id,
    name: tray.name,
    type: TrayFormViewModelType.FaqTray,
    headlineText: { en: tray.headlineTextEnglish, ar: tray.headlineTextArabic },
    questions: tray.questions.map((question) => ({ questionText: question.questionText, answerText: question.answerText })),
    userSegmentIds: tray.userSegmentIds || [],
    countryIds: tray.countryIds || [],
  };
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapViewModelFaqTrayToDomain = (tray: FaqTrayFormViewModel, platformIds: Record<PlatformType, string>): FaqTray => {
  return {
    id: tray.id,
    name: tray.name,
    headlineTextArabic: tray.headlineText.ar,
    headlineTextEnglish: tray.headlineText.en,
    type: 'FaqTray',
    countryIds: tray.countryIds || [],
    userSegmentIds: tray.userSegmentIds || [],
    questions: tray.questions.map((question) => ({ questionText: question.questionText, answerText: question.answerText })),
    order: undefined,
    visible: undefined,
    draggable: false,
    platformIds: Object.values(platformIds),
  };
};
